export enum ReconcileType {
  Unknown = 0,
  Settlement = 1,
  Driver = 2,
  PaidPrior = 3,
  Missing = 4,
  Rejected = 5,
  Unclaimed = 6,
  Ghost = 7,
  Created = 8,
  SoloTeamPay = 9,
  TeamMatchSoloPrimary = 10,
  TeamMatchSoloSecondary = 11,
  SoloMatchTeamSettlement = 12,
  SoloTeamPayDriver = 13,
  TeamMatchSoloPrimaryDriver = 14,
  TeamMatchSoloSecondaryDriver = 15,
  SoloMatchTeamSettlementDriver = 16
}

export const ReconcileTypeMapping: Record<ReconcileType, string> = {
  [ReconcileType.Unknown]: '-- Select Entry --',
  [ReconcileType.Settlement]: 'Approve based on Settlement',
  [ReconcileType.Driver]: 'Approve based on Driver',
  [ReconcileType.PaidPrior]: 'Paid in Prior Week',
  [ReconcileType.Missing]: 'Approve (Driver only)',
  [ReconcileType.Rejected]: 'Reject Driver Ask',
  [ReconcileType.Unclaimed]: 'Move to Unclaimed',
  [ReconcileType.Ghost]: 'Ghost Teammate',
  [ReconcileType.Created]: 'Create for the Driver',
  [ReconcileType.SoloTeamPay]: 'Approve (Solo-Team Pay)',
  [ReconcileType.TeamMatchSoloPrimary]: 'Approve (Team match to Solo - Primary)',
  [ReconcileType.TeamMatchSoloSecondary]: 'Approve (Team match to Solo - Secondary)',
  [ReconcileType.SoloMatchTeamSettlement]: 'Approve (Solo match Team)',
  [ReconcileType.SoloTeamPayDriver]: 'Approve (Solo-Team Pay)',
  [ReconcileType.TeamMatchSoloPrimaryDriver]: 'Approve (Team match to Solo - Primary)',
  [ReconcileType.TeamMatchSoloSecondaryDriver]: 'Approve (Team match to Solo - Secondary)',
  [ReconcileType.SoloMatchTeamSettlementDriver]: 'Approve (Solo match Team)'
};

export const ReconcileTypeForRuleMapping: Record<ReconcileType, string> = {
  [ReconcileType.Unknown]: '-- Select Entry --',
  [ReconcileType.Settlement]: 'Approve based on Settlement',
  [ReconcileType.Driver]: 'Approve based on Driver',
  [ReconcileType.PaidPrior]: 'Paid in Prior Week',
  [ReconcileType.Missing]: 'Ask: Approve',
  [ReconcileType.Rejected]: 'Ask: Reject',
  [ReconcileType.Unclaimed]: 'Settlement: Unclaimed',
  [ReconcileType.Ghost]: 'Ghost Teammate',
  [ReconcileType.Created]: 'Settlement: Create',
  [ReconcileType.SoloTeamPay]: 'Ask: Approve (Solo-Team Pay)',
  [ReconcileType.TeamMatchSoloPrimary]: 'Approve (Team match to Solo - Primary)',
  [ReconcileType.TeamMatchSoloSecondary]: 'Approve (Team match to Solo - Secondary)',
  [ReconcileType.SoloMatchTeamSettlement]: 'Approve (Solo match Team)',
  [ReconcileType.SoloTeamPayDriver]: 'Ask: Approve (Solo-Team Pay)',
  [ReconcileType.TeamMatchSoloPrimaryDriver]: 'Ask: Approve (Team match to Solo - Primary)',
  [ReconcileType.TeamMatchSoloSecondaryDriver]: 'Ask: Approve (Team match to Solo - Secondary)',
  [ReconcileType.SoloMatchTeamSettlementDriver]: 'Ask: Approve (Solo match Team)'
};

export const ReconcileDriverTypes: ReconcileType[] = [
  ReconcileType.Driver,
  ReconcileType.Missing,
  ReconcileType.TeamMatchSoloPrimary,
  ReconcileType.TeamMatchSoloSecondary,
  ReconcileType.SoloMatchTeamSettlement
];
